import {
  configureCheckboxActionButton,
  configureCheckAllCheckbox,
} from '../../components/checkbox'

function initApplicantList() {
  const buttonExportSelected = document.getElementById(
    'btn-export-selected',
  ) as HTMLButtonElement
  const checkboxes = document.getElementsByName(
    'applicant',
  ) as NodeListOf<HTMLInputElement>
  const checkAll = document.getElementById('check-all') as HTMLInputElement

  configureCheckboxActionButton(buttonExportSelected, checkboxes)
  configureCheckAllCheckbox(checkAll, checkboxes, buttonExportSelected)
}
export { initApplicantList }
